import { Box, Button, Card, Typography } from "@luce/ui";

interface PackageDetailFallbackProps {
  message: string;
  onRetry?: () => void;
}

export function PackageDetailFallback({ message, onRetry }: PackageDetailFallbackProps) {
  return (
    <Card gap="none" className="p-spacing-0 border-0 md:border">
      <Box className="gap-spacing-md py-spacing-xl flex flex-col items-center">
        <Typography variant="body-md" color="neutral-foreground-intermediate">
          {message}
        </Typography>
        {onRetry && <Button variant="secondary" size="md" label="Retry" onClick={onRetry} />}
      </Box>
    </Card>
  );
}
